import { browserHistory } from 'react-router'
import { createAction } from 'redux-actions'
import PollService from '../../services/PollService'
import types from './types'

const service = new PollService()

export const createPoll = createAction(types.POLL_CREATE, (data) =>
	service.create(data).then((key) => {
		browserHistory.push(`/${key}/send`)
	})
)

export const removePoll = createAction(types.POLL_REMOVE, (pollId) =>
	service.remove(pollId).then(() => {
		browserHistory.replace('/polls')
		return { key: pollId }
	})
)

export function listenForPoll(pollId) {
	return (dispatch, getState) => {
		if (pollId in getState().polls) return

		service.listen(pollId, (poll) => {
			dispatch({ type: types.POLL_UPDATED, payload: poll })
		})
	}
}

export const update = createAction(types.POLL_UPDATE, (pollId, values) =>
	service.update(pollId, values)
)



// WEBPACK FOOTER //
// ./src/redux/actions/poll.js